function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/SessionApi";
import * as Utility from "../commons/Utility";
import IntlMessage from '../commons/Intl';
import { ActionsHistory, SessionActions } from '../commons/IntlMessages';
import { SessionActionTypes } from "../enum/SessionActionTypes";
import { SessionActionTargetTypes } from "../enum/SessionActionTargetTypes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 会議活動履歴モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 1] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      ActionsHistoryList: [],
      SearchText: "",
      CurrentPage: 1,
      DataCount: 0,
      DataAllCount: 0
    };

    _this.GetList(_this.state.CurrentPage);

    return _this;
  }
  /**
   * リスト表示
   */


  _createClass(MainComponent, [{
    key: "GetList",
    value: function GetList(pageNum) {
      var _this2 = this;

      Api.QueryActionsHistory(this.props.sessionId, this.state.SearchText, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this2.setState({
          ActionsHistoryList: data.ActionsHistoryList,
          DataCount: data.Count,
          DataAllCount: data.AllCount
        });
      });
    }
    /**
     * 前ページ表示
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;

      if (this.state.CurrentPage <= 1) {
        page = 1;
      } else {
        page = this.state.CurrentPage - 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 次ページ表示
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;
      var maxPage = Math.ceil(this.state.DataCount / this.props.pageSize);

      if (maxPage == 0) {
        page = 1;
      } else if (this.state.CurrentPage >= maxPage) {
        page = maxPage;
      } else {
        page = this.state.CurrentPage + 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#SessionActionsHistoryModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * 操作履歴を戻します。
     *
     * @param m 会議操作履歴情報
     */

  }, {
    key: "getActionName",
    value: function getActionName(m) {
      var dataMessage = "";

      switch (m.ActionTargetType) {
        case SessionActionTargetTypes.Session:
          switch (m.ActionType) {
            case SessionActionTypes.Created:
              dataMessage = intl.format(SessionActions.SessionCreated, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Updated:
              dataMessage = intl.format(SessionActions.SessionUpdated, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Deleted:
              dataMessage = intl.format(SessionActions.SessionDeleted, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Copied:
              dataMessage = intl.format(SessionActions.SessionCopied, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Saved:
              dataMessage = intl.format(SessionActions.SessionSaved, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Loaded:
              dataMessage = intl.format(SessionActions.SessionLoaded, {
                user: m.ActionUserName
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.Material:
          switch (m.ActionType) {
            case SessionActionTypes.Added:
              dataMessage = intl.format(SessionActions.MaterialAdded, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName
              });
              break;

            case SessionActionTypes.Updated:
              dataMessage = intl.format(SessionActions.MaterialUpdated, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName
              });
              break;

            case SessionActionTypes.Deleted:
              dataMessage = intl.format(SessionActions.MaterialDeleted, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName
              });
              break;

            case SessionActionTypes.Downloaded:
              dataMessage = intl.format(SessionActions.MaterialDownloaded, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName
              });
              break;

            case SessionActionTypes.Copied:
              dataMessage = intl.format(SessionActions.MaterialCopied, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.Member:
          switch (m.ActionType) {
            case SessionActionTypes.Added:
              dataMessage = intl.format(SessionActions.MemberAdded, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Deleted:
              dataMessage = intl.format(SessionActions.MemberDeleted, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Joined:
              dataMessage = intl.format(SessionActions.MemberJoined, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Exited:
              dataMessage = intl.format(SessionActions.MemberExited, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Copied:
              dataMessage = intl.format(SessionActions.MemberCopied, {
                user: m.ActionUserName
              });

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.Capture:
          switch (m.ActionType) {
            case SessionActionTypes.Created:
              dataMessage = intl.format(SessionActions.CaptureCreated, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Deleted:
              dataMessage = intl.format(SessionActions.CaptureDeleted, {
                user: m.ActionUserName
              });

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.Broadcast:
          switch (m.ActionType) {
            case SessionActionTypes.Started:
              dataMessage = intl.format(SessionActions.BroadcastStarted, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Ended:
              dataMessage = intl.format(SessionActions.BroadcastEnded, {
                user: m.ActionUserName
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.ScreenSharing:
          switch (m.ActionType) {
            case SessionActionTypes.Started:
              dataMessage = intl.format(SessionActions.ScreenSharingStarted, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Ended:
              dataMessage = intl.format(SessionActions.ScreenSharingEnded, {
                user: m.ActionUserName
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.Authoring:
          switch (m.ActionType) {
            case SessionActionTypes.Edit:
              dataMessage = intl.format(SessionActions.AuthoringEdit, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Play:
              dataMessage = intl.format(SessionActions.AuthoringPlay, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Next:
              dataMessage = intl.format(SessionActions.AuthoringNext, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;

            case SessionActionTypes.Back:
              dataMessage = intl.format(SessionActions.AuthoringBack, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;

            case SessionActionTypes.Reset:
              dataMessage = intl.format(SessionActions.AuthoringReset, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Select:
              dataMessage = intl.format(SessionActions.AuthoringSelect, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;

            case SessionActionTypes.Answer:
              dataMessage = intl.format(SessionActions.AuthoringAnswer, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;
          }

          break;

        case SessionActionTargetTypes.Streaming:
          switch (m.ActionType) {
            case SessionActionTypes.Started:
              dataMessage = intl.format(SessionActions.StreamingStarted, {
                user: m.ActionUserName
              });
              break;

            case SessionActionTypes.Ended:
              dataMessage = intl.format(SessionActions.StreamingEnded, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;
          }

          break;

        case SessionActionTargetTypes.VoiceMemo:
          switch (m.ActionType) {
            case SessionActionTypes.Created:
              dataMessage = intl.format(SessionActions.VoiceMemoCreated, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName,
                memo: m.ActionMemo
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.StickyNote:
          switch (m.ActionType) {
            case SessionActionTypes.Created:
              dataMessage = intl.format(SessionActions.StickyNoteCreated, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;

            case SessionActionTypes.Updated:
              dataMessage = intl.format(SessionActions.StickyNoteUpdated, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.Translation:
          switch (m.ActionType) {
            case SessionActionTypes.Spoken:
              dataMessage = intl.format(SessionActions.TranslationSpoken, {
                user: m.ActionUserName,
                memo: m.ActionMemo
              });
              break;

            default:
              break;
          }

          break;

        case SessionActionTargetTypes.ChatBot:
          switch (m.ActionType) {
            case SessionActionTypes.Spoken:
              dataMessage = intl.format(SessionActions.ChatBotSpoken, {
                user: m.ActionUserName,
                material: m.ActionTargetFileName,
                memo: m.ActionMemo
              });
              break;

            default:
              break;
          }

          break;

        default:
          break;
      }

      return dataMessage;
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionActionsHistoryModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/assethistory_icon.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(ActionsHistory.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 col-lg-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-6 search-btn"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.ActionsHistoryList.length == 0 && /*#__PURE__*/React.createElement("li", {
        className: "list-group-item",
        key: 0
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }, "-"), /*#__PURE__*/React.createElement("div", {
        className: "col-11",
        style: {
          wordWrap: "break-word"
        }
      }, intl.format(ActionsHistory.NoActivity)))), this.state.ActionsHistoryList.length > 0 && this.state.ActionsHistoryList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.Id
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-1"
        }, (_this4.state.CurrentPage - 1) * _this4.props.pageSize + _i + 1), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          style: {
            wordWrap: "break-word"
          }
        }, Utility.ToMoment(x.ActionDateTime).format("YYYY-MM-DD HH:mm:ss")), /*#__PURE__*/React.createElement("div", {
          className: "col-8 cursorpointer",
          style: {
            wordWrap: "break-word"
          }
        }, _this4.getActionName(x))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1 offset-10 text-right"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })))))))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };